import { render } from "./NoData.vue?vue&type=template&id=160894a3&scoped=true"
import script from "./NoData.vue?vue&type=script&lang=js"
export * from "./NoData.vue?vue&type=script&lang=js"

import "./NoData.vue?vue&type=style&index=0&id=160894a3&lang=scss&scoped=true"

import exportComponent from "D:\\svn_gongzuo\\_____base\\GoPay\\v3_gopay\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-160894a3"]])

export default __exports__